import {reject, isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getCustomerEmails = (customer: CustomerResponseBodyV2 | Nullish) => {
  const businessEmails = customer?.contacts.flatMap((contact) =>
    contact.emails.flatMap((email) => email.email)
  );
  const foundingPersonEmails = customer?.foundingPerson?.emails.map((email) => email.email);
  const contactEmails = customer?.contacts?.flatMap((contact) =>
    contact.emails.flatMap((email) => email.email)
  );
  const contractInformationEmails = customer?.contractInformation.flatMap((contract) =>
    contract.person?.emails.flatMap((email) => email.email)
  );

  const emails =
    customer?.discriminator === 'BUSINESS'
      ? businessEmails
      : [
          ...(foundingPersonEmails ?? []),
          ...(contractInformationEmails ?? []),
          ...(contactEmails ?? []),
        ];

  const uniqueEmails = new Set(reject(isNil, emails ?? []));

  return Array.from(uniqueEmails).map((email) => ({value: email, label: email}));
};
